import styled from '@emotion/styled';
import {Submit} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const Recipes = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginTop: 42,
  '& > a:nth-of-type(2n+1)': {
    marginRight: 5,
  },
});

export const Button = styled(Submit)({
  margin: '0 auto',
});

export const ArticleTeasers = styled('div')({
  marginTop: 40,
});
